import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=guest, obj=user
  const [impersonating, setImpersonating] = useState(!!localStorage.getItem("eim_admin_token"));

  const refresh = async () => {
    const token = localStorage.getItem("eim_token");
    if (!token) { setUser(false); return; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      localStorage.removeItem("eim_token");
      setUser(false);
    }
  };

  useEffect(() => { refresh(); }, []);

  const loginWith = (token, userData) => {
    localStorage.setItem("eim_token", token);
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem("eim_token");
    localStorage.removeItem("eim_admin_token");
    setImpersonating(false);
    setUser(false);
  };

  // El personal asume temporalmente la cuenta de un socio para crear/completar su solicitud.
  const startImpersonation = (token, userData) => {
    const current = localStorage.getItem("eim_token");
    if (current) localStorage.setItem("eim_admin_token", current);
    localStorage.setItem("eim_token", token);
    setImpersonating(true);
    setUser(userData);
  };

  const stopImpersonation = async () => {
    const adminToken = localStorage.getItem("eim_admin_token");
    if (adminToken) {
      localStorage.setItem("eim_token", adminToken);
      localStorage.removeItem("eim_admin_token");
    }
    setImpersonating(false);
    await refresh();
  };

  return (
    <AuthContext.Provider value={{ user, setUser, loginWith, logout, refresh, impersonating, startImpersonation, stopImpersonation }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
